export default process.env.NODE_ENV === 'production' ? 'https://parcari-s4.verdedata.ro' : 'http://localhost:5555'
